import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import BasicBanner from "@components/BasicBanner/BasicBanner";
import Meta from "@components/Meta/Meta";
import Pagination from "@components/Pagination/Pagination";
import * as CMSActions from "app/@Base/store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";
import * as CMSActionsAhorro from "../../store/actions";
import phone_icon from "../../../../../../assets/img/phone_icon.png";
import website_icon from "../../../../../../assets/img/website_icon.png";
import facebook_icon from "../../../../../../assets/img/facebook_icon.png";
import instagram_icon from "../../../../../../assets/img/instagram_icon.png";

import "./Convenios.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;
const PAGE_SIZE = 10;

const Convenios = () => {
  const dispatch = useDispatch();
  const [banner, setBanner] = useState({});
  const [contractTypes, setContractTypes] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [filters, setFilters] = useState({});
  const [searching, setSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const filteredContracts = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PAGE_SIZE;
    const lastPageIndex = firstPageIndex + PAGE_SIZE;
    return contracts?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, contracts]);

  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  //Selectores de estado
  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { loggedUser } = useSelector(({ Base }) => Base?.User);
  const { tiposConvenios } = useSelector(({ Base }) => Base.Catalogos);
  const { convenios } = useSelector(({ Base }) => Base.Catalogos);
  const { conveniosCMS } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter((route) => route?.name === "Convenios");

  useEffect(() => {
    dispatch(CMSActionsAhorro.getCMSConvenios());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { token } = loggedUser;
    if (token) {
      isEmpty(tiposConvenios) && dispatch(CMSActions.getTiposConvenios(token));
      isEmpty(convenios) && dispatch(CMSActions.getConvenios(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser]);

  useEffect(() => {
    !isEmpty(tiposConvenios) && setContractTypes(tiposConvenios);
  }, [tiposConvenios]);

  useEffect(() => {
    !isEmpty(convenios) && setContracts(convenios);
  }, [convenios]);

  useEffect(() => {
    if (!isEmpty(conveniosCMS)) {
      let backgroundImage;
      let mainImage = {
        img: ROOT + conveniosCMS.aCBannerConvenios[0].heroImage.urls[0],
        alt: "Convenios",
      };
      let title = conveniosCMS.aCBannerConvenios[0].copyText?.html;
      let description = conveniosCMS.aCBannerConvenios[0].descripcion?.html;

      if (isIphoneLandscape) {
        backgroundImage =
          ROOT + conveniosCMS.aCBannerConvenios[0].imagendefondoMovil.urls[0];
      } else if (isIpadPortrait) {
        backgroundImage =
          ROOT + conveniosCMS.aCBannerConvenios[0].imagendeFondoIpad.urls[0];
      } else if (isDesktop) {
        backgroundImage =
          ROOT + conveniosCMS.aCBannerConvenios[0].imagendefondo.urls[0];
      }

      setBanner({
        backgroundImage: {
          img: backgroundImage,
          alt: "Banner de Convenios",
        },
        mainImage: mainImage,
        title: title,
        description: description,
      });
    }
  }, [conveniosCMS, isIphoneLandscape, isIpadPortrait, isDesktop]);

  const filterContracts = () => {
    if (!isEmpty(filters)) {
      let filtersEmpty = true;
      let contractsFiltered = [];
      // Recorre cada filtro ingresado
      Object.keys(filters).forEach((key) => {
        // valida si posee filtro de tipo de convenio, y un valor valido.
        if (
          key === "ContractType" &&
          !isEmpty(filters[key]) &&
          +filters[key] !== 0
        ) {
          filtersEmpty = false;
          if (contractsFiltered.length === 0) {
            contractsFiltered = [
              ...contractsFiltered,
              ...convenios.filter(
                (convenio) => convenio.IdTipoConvenio === +filters[key]
              ),
            ];
          } else {
            contractsFiltered = contractsFiltered.filter(
              (convenio) => convenio.IdProvincia === +filters[key]
            );
          }
          // si no tiene resultados termina el filtrado.
          if (contractsFiltered.length === 0) {
            return;
          }
        }
      });
      // Si los filtros estaban vacios devuelve todos los convenios o caso contrario las filtradas
      filtersEmpty ? setContracts(convenios) : setContracts(contractsFiltered);
    } else {
      setContracts(convenios);
    }
  };

  useEffect(() => {
    if (searching) {
      filterContracts();
      setSearching(false);
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searching]);

  const filterHandler = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <div className="contract-container">
        <BasicBanner
          backgroundImage={banner.backgroundImage}
          mainImage={banner.mainImage}
          title={banner.title}
          description={banner.description}
        />
        <div className="filters-container">
          <h2 className="filter-title">Buscar convenios por:</h2>
          <div className="filter-form">
            <div className="form-group">
              <label className="form-label" htmlFor="ContractType">
                Tipos de convenios
              </label>
              <select
                className="form-select3"
                id="ContractType"
                name="ContractType"
                onChange={filterHandler}
              >
                <option key={0} value={0}>
                  Todos
                </option>
                {contractTypes.map((item, index) => {
                  return (
                    <option key={index + 1} value={item.Id}>
                      {item.Nombre + " (" + item.CantConveniosAsociados + ")"}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="btn-container">
              <button
                className="form-btn"
                type="button"
                id="SearchButton"
                onClick={() => setSearching(true)}
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
        <div className="contracts-list">
          {!isEmpty(filteredContracts) ? (
            <>
              {filteredContracts.map((contract, index) => (
                <div key={index} className="contract-item">
                  <div className="contract-card">
                    <div className="contract-title">{contract.Titulo}</div>
                    <div className="contract-body">
                      <div className="contract-image">
                        <img
                          src={contract.ImagenRelacionada}
                          alt={contract.Titulo}
                        />
                      </div>
                      <div className="contract-detail">
                        <span>{contract.Descripcion}</span>
                        <div className="contact-info">
                          <strong>Datos de contacto:</strong>
                        </div>
                        {contract.Telefono && (
                          <div className="phone-row">
                            <a
                              href={`tel:${contract.Telefono}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                className="contract-icon"
                                src={phone_icon}
                                alt="icono de telefono"
                              />
                              <span className="phone-number">
                                Tel: {contract.Telefono}
                              </span>
                            </a>
                          </div>
                        )}
                        <div className="anchor-row">
                          {contract.SitioWeb && (
                            <a
                              href={contract.SitioWeb}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                className="contract-icon"
                                src={website_icon}
                                alt="sitio web"
                              />
                            </a>
                          )}
                          {contract.PerfilFacebook && (
                            <a
                              href={`https://www.facebook.com/${contract.PerfilFacebook}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                className="contract-icon"
                                src={facebook_icon}
                                alt="Perfil de facebook"
                              />
                            </a>
                          )}
                          {contract.PerfilInstagram && (
                            <a
                              href={`https://www.instagram.com/${contract.PerfilInstagram}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                className="contract-icon"
                                src={instagram_icon}
                                alt="Perfil de instagram"
                              />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={contracts.length}
                pageSize={PAGE_SIZE}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </>
          ) : (
            <div className="contract-title">
              No se han encontrado convenios.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Convenios;
